import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setIsBubbleOpen } from "../../../store/actions/contentActions";
import "./ContentSideArea.scss";

export const ContentSideArea = () => {
  const { isBubbleOpen, currentPost } = useSelector((state: any) => state.content);
  const dispatch = useDispatch();

  const closeContentSideArea = () => {
    dispatch(setIsBubbleOpen(false));
  };

  return (
    <>
      {currentPost && currentPost.user[0] ? (
        <div className={isBubbleOpen ? "post-side-area open" : "post-side-area"}>
          <div className="container px-4 py-3">
            <div className="row justify-content-between align-items-start">
              <div className="img-wrapper my-2">
                {currentPost && currentPost.user[0].image ? (
                  <img src={currentPost.user[0].image ? currentPost.user[0].image : ""} alt="" />
                ) : (
                  <div className="postBubbleInitials">{currentPost.user[0].firstName.charAt(0).toUpperCase() + currentPost.user[0].lastName.charAt(0).toUpperCase()}</div>
                )}
              </div>
              <CloseIcon className="pointer" onClick={() => closeContentSideArea()} sx={{ cursor: "pointer" }} />
            </div>
            <div className="row my-0">
              <div className="title">
                Shared by <span className="">{currentPost.user[0].fullName}</span>
              </div>
            </div>
            <div className="row">
              <div className="extra-data">
                {currentPost.community[0]?.name} | {moment(currentPost.created).fromNow()} &nbsp;
              </div>
            </div>
            <div className="row my-3">
              <div className="post">{currentPost.post}</div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
